import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B12({data, globalVariables, assoc_data,message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.SKW000.error_id: {
            return `Flow Data could not be checked since the flow profiles are not labeled!`
        }
        case MessageCodes.Internal.XY17.error_id: {
            return (
                <>
                    {
                        row?.data?.map(r => (
                            <ResultText>
                                Cross section cutline does not intersect with the stream centerline at RS {r.cross_section}. In order to calculate the skew angle, the stream centerline is extended.
                            </ResultText>
                        ))
                    }
                </>
            )
        }
        case MessageCodes.Internal.XY05.error_id: {
            return (
                <>
                    <ResultText>
                        The cross-section cutlines are skewed from normal to stream centerline more than {settings.thresholds.skew_angle} degrees at the following {row.data.length} cross sections. The measured skew angles and (if any) defined skew angles are listed in the following table. If the defined skew angle is not within {settings.thresholds.skew_deviation} % of the measured skew angle, they are highlighted in red. Minus sign indicates clockwise skew.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center'}} colSpan={2}>Skew Angle</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Measured</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Defined</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{
                                            <CheckCSName csName={r.cross_section} />
                                        }</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.skew}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{renderDefinedSkew(r)}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XY06.error_id: {
            return (
                <>
                    <ResultText>
                        The bridges are skewed from normal to stream centerline more than {settings.thresholds.skew_angle} degrees at the following {row.data.length} bridges. The measured skew angles and (if any) defined skew angles are listed in the following table. If the defined skew angle is not within {settings.thresholds.skew_deviation} % of the measured skew angle, they are highlighted in red.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center'}} colSpan={2}>Skew Angle</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Measured</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Defined</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{(r?.skew_map && parseInt(r?.skew_map)) ?? r.skew}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{renderDefinedSkew(r)}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XY07.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    Cross section cutline doesn't intersect with the stream centerline at RS <CheckCSName csName={x.cross_section} />.
                                    <EmptyLine />
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.XY08.error_id: {
            return (
                <>
                    <ResultText>Skew Angle could not be calculated for the following {row?.data?.length} cross sections since they are not georeferenced:</ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.XY09.error_id: {
            return (
                <>
                    <ResultText>Skew Angle could not be calculated for the following {row?.data?.length} bridges since their bounding cross sections are not georeferenced.</ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const renderDefinedSkew = (r) => {
    // Backend marker is the single source of truth: false = problem (missing or
    // out-of-range). Render the value in red when the row is flagged; if there
    // is no defined value the red span just has empty content, which is fine.
    if (r?.defined_skew_in_range === false && r?.defined_skew != null) {
        return <span style={{color: 'red'}}>{r.defined_skew}</span>
    }
    return r?.defined_skew
}